export default {
  name: 'ToastMixin',
  methods: {
    toast (type, message) {
      this.$message({ type, message })
    },
    errorHandler ({ message }) {
      if (message) {
        this.$message({ type: 'error', message })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/toast.js